import { render, staticRenderFns } from "./VaimoTabs.vue?vue&type=template&id=3e723d18&scoped=true&"
import script from "./VaimoTabs.vue?vue&type=script&lang=js&"
export * from "./VaimoTabs.vue?vue&type=script&lang=js&"
import style0 from "./VaimoTabs.vue?vue&type=style&index=0&id=3e723d18&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e723d18",
  null
  
)

export default component.exports